import { Component, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormGroupField } from './form-group.model';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-group',
  templateUrl: './form-group.component.html',
  styleUrls: ['./form-group.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormGroupComponent<N = any> extends FormBaseComponent<FormGroupField<N>> {

  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }


  constructor(
    cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() { }
  onComponentDestroy() { }

}
